import React, { Component } from 'react'
import { Switch, Route } from 'react-router-dom'

// Components
import StoreLocationSearch from './StoreLocationSearch'
import AdminStoreLocationForm from './AdminStoreLocationForm'

class AdminStoreLocationEdit extends Component {
    render() {
        return (
            <div>
                <h1>Edit Store Location</h1>

                <Switch>
                    <Route path={'/admin/store-locations/edit'} exact component={StoreLocationSearch} />
                    <Route path={'/admin/store-locations/edit/:permalink'} component={AdminStoreLocationForm} />
                </Switch>
            </div>
        )
    }
}

export default AdminStoreLocationEdit



// WEBPACK FOOTER //
// ./src/components/admin/store-locations/AdminStoreLocationEdit.js